<template>
    <div>
        <div class="DebugView" v-if="scenario">
            <div style="height: 100%">
                <!--Header page-->
                <DebugHeader/>
                <!--Content-->
                <div class="display-flex main-content">
                    <DebugHistoryLogs/>
                    <template v-if="Object.keys(treeDebugData).length > 0">
                        <DebugFlow/>
                        <DebugNodeEditor />
                    </template>
                    <div class="centerXY not-found-box" v-else>
                        {{ isDataFlowError ? $f.tc('debugModeNotSupportForCall') : $f.tc('notFoundCall') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import DebugNodeEditor from "@/views/Debug/DebugNodeEditor.vue";
import DebugHeader from "@/views/Debug/DebugHeader.vue";
import DebugHistoryLogs from "@/views/Debug/DebugHistoryLogs.vue";
import DebugFlow from "@/views/Debug/DebugFlow.vue";

export default {
    name: 'DebugView',
    components: {DebugFlow, DebugHistoryLogs, DebugHeader, DebugNodeEditor},
    data() {
        return {
            scenarioId: ''
        }
    },
    computed: {
        ...mapState({
            navigation: state => state.navigation,
            treeData: state => state.scenario.treeData,
            scenario: state => state.scenario.scenario,
            scenarioSetting: state => state.scenario.scenario_setting,
            treeDebugData: state => state.debug.treeData,
            isDataFlowError: state => state.debug.isDataFlowError,
        }),
    },
    mounted() {
        this.loadScenarioData()
    },
    methods: {

        // functions load and handle data
        loadScenarioData() {
            return this.$store.dispatch(this.$actionTypes.scenario.GET_TREE_DATA, this.scenarioId)
        },
    }
}
</script>

<style scoped lang="scss">
@import "../Scenario/draw/tree";
@import "../Scenario/scenarioLayout";

.DebugView {
    height: calc(100vh - 60px);
    overflow: hidden;
    position: relative;
    font-family: "open sans", serif;

    .input-custom {
        position: relative;

        ::v-deep {
            .v-input__slot {
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DBDBDB;
                outline: none;
                outline-offset: 0;
                font-size: 14px;
                margin: 0;
                display: flex;
                align-items: center;
                height: 32px;
                padding: 6px 12px;
                font-family: "open sans", serif !important;

                &:before, &:after {
                    border: none !important;
                }
            }
        }
    }

    .main-content {
        height: calc(100vh - 170px);
    }
}

.main-content {
    .tree-debug {
        flex: 1;
        height: 100%;
        background: #FCFBFC;
        padding-right: 0;
        position: relative;
        overflow: hidden;
        z-index: 0;

        .group-btn-tree {
            position: absolute;
            right: 14px;
            bottom: 15px;
        }

        ::v-deep .all-scroll {
            cursor: all-scroll;
        }

        &::-webkit-scrollbar {
            display: none;
        }

        &::v-deep .svg-tree-debug {
            position: absolute;
            top: 0;
            left: 0;
            transition: top, left 0.3s ease;
        }
    }

    .right-container {
        width: 495px;
        background: #FFFFFF;
        border-left: 1px solid #EFEFEF;
        z-index: 1;
        box-shadow: -1px 4px 15px 0 rgba(0, 0, 0, 0.05);
    }

    .not-found-box {
        flex: 1;
        font-family: "open sans", serif;
        font-size: 14px;
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    input::placeholder {
        font-family: "open sans", serif;
        font-size: 14px !important;
    }
}
</style>
